import { Injectable, OnDestroy } from '@angular/core';
import { CanActivate } from '@angular/router';
import { select, Store } from '@ngrx/store';
import { Subscription, combineLatest } from 'rxjs';
import { map, mergeMap, skipWhile, take, withLatestFrom } from 'rxjs/operators';
import { AuthService } from 'src/app/auth/auth.service';
import * as appSelectors from '../../state/app/app.selectors';
import { environment } from 'src/environments/environment';
import { AppSelectors } from 'src/app/state/app';

@Injectable({
  providedIn: 'root'
})
export class AdminOrSupportGuard implements CanActivate {
  constructor(
    private store: Store,
    private authService: AuthService) {
  }

  user$ = this.store.pipe(select(AppSelectors.getUser));

  canActivate() {
    if (environment.testing) {
      return true;
    }

    return this.user$.pipe(
      skipWhile((user) => !user || !this.authService.ready),
      map(user => user.roles.isSupport || user.roles.isAdmin)
    );
  }
}
